import React, { FunctionComponent, useEffect, useState } from 'react';
import { Prompt, useHistory } from 'react-router-dom';
import { ConfirmModal } from '.';
import { ConfirmModalProps } from './modal/confirm-modal';

export interface NavigateGuardProps {
  when: boolean;
  message?: string;
}

const NavigateGuard: FunctionComponent<NavigateGuardProps> = ({
  when = false, message,
}: NavigateGuardProps) => {
  const [confirmModalProps, setConfirmModalProps] = useState<ConfirmModalProps>({ show: false });
  const [lastLocation, setLastLocation] = useState<Location | null>(null);
  const [confirmedNavigation, setConfirmedNavigation] = useState<boolean>(false);
  const history = useHistory();

  const closeModal = () => {
    setConfirmModalProps({ show: false });
  };

  const handleConfirmNavigationClick = () => {
    closeModal();
    setConfirmedNavigation(true);
  };

  const handleBlockedNavigation = (nextLocation: any, action: any): boolean => {
    if (!confirmedNavigation) {
      setConfirmModalProps({
        show: true,
        detail: message,
        onConfirm: handleConfirmNavigationClick,
        onCancel: closeModal,
      });
      setLastLocation(nextLocation);
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (confirmedNavigation && lastLocation) {
      history.push(lastLocation.pathname);
    }
  }, [confirmedNavigation, history, lastLocation]);

  return (
    <>
      <Prompt when={when} message={handleBlockedNavigation} />
      <ConfirmModal {...confirmModalProps} />
    </>
  );
};

export default NavigateGuard;
